module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-content"
  }, [_c('div', {
    staticClass: "uk-padding"
  }, [_vm._m(0), _vm._v(" "), _c('h1', {
    staticClass: "uk-align-left"
  }, [_vm._v("Gebruikers")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('table', {
    staticClass: "uk-table"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.users), function(u, id) {
    return _c('tr', [_c('td', [(u.photoURL) ? _c('img', {
      staticClass: "round",
      attrs: {
        "width": "30",
        "src": u.photoURL
      }
    }) : _c('span', {
      attrs: {
        "uk-icon": "icon: user; ratio: 1.2"
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(u.displayName))]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": 'mailto:' + u.email
      }
    }, [_vm._v(_vm._s(u.email))])]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": 'tel:' + u.phone
      }
    }, [_vm._v(_vm._s(u.phone))])]), _vm._v(" "), (_vm.roles && _vm.roles[id]) ? _c('td', [_vm._v(_vm._s(_vm.userRoles[_vm.roles[id].role - 1]))]) : _vm._e(), _vm._v(" "), _c('td', [(_vm.roles[id.role < 4] || _vm.$store.state.core.user.role >= 4) ? _c('router-link', {
      staticClass: "uk-link",
      attrs: {
        "to": {
          name: 'UserDetail',
          params: {
            id: id
          }
        },
        "uk-icon": "icon: cog"
      }
    }) : _vm._e()], 1)])
  }))])]), _vm._v(" "), (Object.keys(_vm.newUsers).length > 0 && _vm.newUsers.constructor === Object) ? _c('div', {
    staticClass: "uk-padding"
  }, [_c('h4', [_vm._v("Gebruikers worden toegevoegd")]), _vm._v(" "), _c('table', {
    staticClass: "uk-table"
  }, [_vm._m(3), _vm._v(" "), _c('tbody', _vm._l((_vm.newUsers), function(u, id) {
    return _c('tr', [_vm._m(4, true), _vm._v(" "), _c('td', [_vm._v(_vm._s(u.firstname + ' ' + u.lastname))]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": 'mailto:' + u.email
      }
    }, [_vm._v(_vm._s(u.email))])]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": 'tel:' + u.phone
      }
    }, [_vm._v(_vm._s(u.phone))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(u.error))])])
  }))])]) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "invite-modal",
      "uk-modal": ""
    }
  }, [_c('div', {
    staticClass: "uk-modal-dialog"
  }, [_c('button', {
    staticClass: "uk-modal-close-default",
    attrs: {
      "type": "button",
      "uk-close": ""
    }
  }), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "uk-modal-body"
  }, [_c('form', [_c('fieldset', {
    staticClass: "uk-fieldset"
  }, [_c('div', {
    staticClass: "uk-margin"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newInvite.firstname),
      expression: "newInvite.firstname"
    }],
    staticClass: "uk-input",
    attrs: {
      "type": "text",
      "placeholder": "Voornaam"
    },
    domProps: {
      "value": (_vm.newInvite.firstname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newInvite, "firstname", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "uk-margin"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newInvite.lastname),
      expression: "newInvite.lastname"
    }],
    staticClass: "uk-input",
    attrs: {
      "type": "text",
      "placeholder": "Naam"
    },
    domProps: {
      "value": (_vm.newInvite.lastname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newInvite, "lastname", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "uk-margin"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newInvite.email),
      expression: "newInvite.email"
    }],
    staticClass: "uk-input",
    attrs: {
      "type": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.newInvite.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newInvite, "email", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "uk-modal-footer"
  }, [_c('div', {
    staticClass: "uk-align-right"
  }, [_c('button', {
    staticClass: "uk-button uk-button-primary uk-align-right uk-modal-close",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.invite($event)
      }
    }
  }, [_vm._v("Uitnodigen")]), _vm._v(" "), _c('button', {
    staticClass: "uk-button uk-button-danger uk-align-right uk-modal-close",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.cancel($event)
      }
    }
  }, [_vm._v("Annuleren")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "uk-breadcrumb"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("Gebruikers")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "uk-align-right"
  }, [_c('a', {
    attrs: {
      "href": "#invite-modal",
      "uk-toggle": "",
      "uk-icon": "icon: plus; ratio: 2"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "width": "30"
    }
  }), _vm._v(" "), _c('th', [_vm._v("Naam")]), _vm._v(" "), _c('th', [_vm._v("Email")]), _vm._v(" "), _c('th', [_vm._v("gsm")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "30"
    }
  }, [_vm._v("Rol")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "60"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "width": "30"
    }
  }), _vm._v(" "), _c('th', [_vm._v("Naam")]), _vm._v(" "), _c('th', [_vm._v("Email")]), _vm._v(" "), _c('th', [_vm._v("gsm")]), _vm._v(" "), _c('th')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('div', {
    attrs: {
      "uk-spinner": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "uk-modal-header"
  }, [_c('h2', {
    staticClass: "uk-modal-title"
  }, [_vm._v("Gebruiker uitnodigen")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-510013a2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/CORE/pages/Users.vue
// module id = 514
// module chunks = 1